import React, { useEffect, useState } from "react";
import { cellRendererCheck } from "utils/columns";
import ReactStrapTable from "components/reactStrapTable";
import useAxios from "hooks/useAxios";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  Button,
} from "reactstrap";
import DrugUtilizationDrawer from "pages/ClientDashBoard/Components/GridData/GridReports/DrugCostvsUtilizationDrawer";
import Drawer from "components/Drawer";
import ErrorBoundary from "components/ErrorBoundary";
const DrugCostUtilization = ({ drugCostUtilization, dateRange, planId, groupId, startDate,endDate,rebatechecked }) => {
  
  const API = useAxios();
  const [summaryData, setSummaryData] = useState([]);
     const [isOpen, setIsOpen] = useState(false);
  const handleProceed = () => {
    setIsOpen(!isOpen);
  };
  const currencyFormat = (value) => {
    if (!value || isNaN(value)) return "-";
    if (value < 0)
      return (
        <span className="text-danger text-end">
          {"-$" +
            (value * -1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </span>
      );
    else
      return (
        <span className="text-end">
          {"$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </span>
      );
  };
      const onHandleIsOpen = (hasRefresh)=> {
      
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
      }
  const GetDrugCostUtilizationColumns = [
    {
      dataField: "drugName",
      text: "Drug Name",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (drugCostUtilization) =>
        cellRendererCheck(drugCostUtilization.drugName),
    },
    
    {
      dataField: "totalMount",
      text: "Total Spend",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (drugCostUtilization) =>
        currencyFormat(drugCostUtilization.totalMount),
    },
    {
      dataField: "count",
      text: "RX Count",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (drugCostUtilization) =>
        cellRendererCheck(drugCostUtilization.count),
    },

  ];
  const [disabledViewButtom, setDisabledViewButtom] = useState(true);
  // ✅ Sample Data

  // If you want to test setting one of these to summaryData, do it here:
  useEffect(() => {
    if (Array.isArray(drugCostUtilization) && drugCostUtilization.length > 0) {
      setDisabledViewButtom(false);
    } else {
      setDisabledViewButtom(true);
    }
  }, [drugCostUtilization, dateRange, planId, groupId, startDate, endDate]);

  return (
    <ErrorBoundary>
    <Card className="p-3 h-100">
      <CardHeader className="border-0 bg-white px-0 pt-0">
        <Row className="align-items-center">
          <Col>
            <CardTitle className="f-20 font-weight-500">
             Top 10 Drug Cost vs Utilization
            </CardTitle>
          </Col>
        </Row>
      </CardHeader>

      <CardBody className="dashboard-chart-body">
        <div
          className={`table-card scroll-table position-relative border-0 rounded pt-0 scroll  ${
            drugCostUtilization?.length > 0 ? "fixed-height" : "default"
          }`}
        >
          <ReactStrapTable
            columns={GetDrugCostUtilizationColumns}
            data={drugCostUtilization || []}
          />
        </div>
        <div className="view-report">
          <Button
            color="primary"
            className="ms-2"
            onClick={handleProceed}
            style={{ float: "right", marginTop: "26px" }}
            disabled={disabledViewButtom}
          >
            View Report
          </Button>
        </div>
      </CardBody>
    </Card>
     <Drawer
                direction='end'
                title='Top 10 Drug Cost vs Utilization'
                isOpen={isOpen}
                toggle={handleProceed}
                size="lg"
            >
                    <DrugUtilizationDrawer  dateRange={dateRange} planId={planId} groupId={groupId} startDate={startDate} endDate={endDate} rebatechecked={rebatechecked} onHandleIsOpen={onHandleIsOpen} />
            </Drawer> 
    </ErrorBoundary>
  );
};

export default DrugCostUtilization;
